<template>
  <div>
    <!-- <el-row>
            <div class="model-header">
                <h2>Kết quả thi học viên : {{ modelData.user_txt }}</h2>
                <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
            </div>
        </el-row> -->
    <el-row>
      <!-- <div v-if="modelData.id">
                <test-result-index :user_id="modelData.user_id"></test-result-index>
            </div> -->
      <h2>Thông tin về lớp học:</h2>
      <div class="model-content">
        <el-col :span="24">
          <el-row :gutter="20">
            <el-col :span="24" v-if="modelData">
              <el-form label-position="top" :model="modelData" ref="createModel" label-width="160px">
                <el-row gutter="20">
                  <el-col :span="12">
                    <el-form-item prop="name" label="Tên lớp học:" class="form-item" :rules="[
                      { required: true, message: 'Vui lòng nhập tên lớp học' }
                    ]">
                      <el-input v-model="modelData.name" class="input-seach"></el-input>
                    </el-form-item>
                    <el-form-item prop="host_id" label="Giảng viên:" class="form-item">
                      <el-select filterable v-model="modelData.teacher.id" placeholder="Chọn giảng viên" :rules="[
                        { required: true, message: 'Vui lòng chọn giảng viên' }
                      ]">
                        <el-option v-for="item in teacher" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item prop="course_id" label="Khóa học:" class="form-item">
                      <el-select v-model="modelData.course_id" placeholder="Chọn giảng viên">
                        <el-option v-for="item in courses" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item prop="limit_account" label="Giới hạn người tham gia:" class="form-item">
                      <el-input v-model="modelData.limit_account" class="input-seach"></el-input>
                    </el-form-item>
                    <el-form-item prop="price" label="Giá tiền:" class="form-item">
                      <el-input v-model="modelData.price" class="input-seach"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="time_start" label="Ngày bắt đầu:" class="form-item" :rules="[
                      { required: true, message: 'Vui lòng nhập ngày bắt đầu' }
                    ]">
                      <el-date-picker :size="'large'" type="date" v-model="modelData.time_start"
                        class="input-seach"></el-date-picker>
                    </el-form-item>
                    <el-form-item prop="time_end" label="Ngày kết thúc:" class="form-item" :rules="[
                      { required: true, message: 'Vui lòng nhập ngày kết thúc' }
                    ]">
                      <el-date-picker type="date" v-model="modelData.time_end" class="input-seach"></el-date-picker>
                    </el-form-item>
                    <el-form-item prop="start_at" label="Bắt đầu:" class="form-item" :rules="[
                      { required: true, message: 'Vui lòng nhập thời gian bắt đầu' }
                    ]">
                      <el-time-picker v-model="modelData.start_at" class="input-seach"></el-time-picker>
                    </el-form-item>
                    <el-form-item prop="end_at" label="Kết thúc:" class="form-item" :rules="[
                      { required: true, message: 'Vui lòng nhập thơi gian kết thúc' }
                    ]">
                      <el-time-picker v-model="modelData.end_at" class="input-seach"></el-time-picker>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item prop="date_in_week" label="Các ngày trong tuần:" class="form-item">
                      <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate" @change="handleCheckAllChange">Chọn
                        tất cả</el-checkbox>
                      <el-checkbox-group v-model="modelData.date_in_week" @change="handleCheckeDate">
                        <el-checkbox v-for="date in dateInWeek" :key="date.value" :label="date.value">
                          {{ date.name }}
                        </el-checkbox>
                      </el-checkbox-group>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row gutter="20">
                  <el-col :span="12">
                    <el-form-item prop="users" label="Danh sách học viên" class="form-item" style="width: 100%">
                      <el-select style="width: 100%" fit-input-width filterable v-model="modalDataUser" multiple
                        placeholder="Chọn học viên" collapse-tags-tooltip :max-collapse-tags="10">
                        <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="name" label="Danh sách trợ giảng" class="form-item">
                      <el-select filterable v-model="modalDataTurTors" multiple placeholder="Chọn trợ giảng"
                        collapse-tags-tooltip :max-collapse-tags="10">
                        <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row gutter="20">
                  <!--                                //submit-->
                  <el-col :span="24" style="text-align: right">
                    <el-button type="primary" @click="submitForm('createModel')" :disable="!canSubmit"
                      :loading="!canSubmit">Lưu</el-button>
                    <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
                  </el-col>
                </el-row>
              </el-form>
            </el-col>
            <!--                        <el-col :span="15">-->
            <!--                            <el-form label-position="top" :model="modelData.course" ref="createModel">-->
            <!--&lt;!&ndash;                                <img v-if="modelData.course.data.image_path" :src="modelData.course.data.image_path" class="course">&ndash;&gt;-->
            <!--                            </el-form>-->
            <!--                        </el-col>-->
          </el-row>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import moment from 'moment'
import { head } from 'lodash'
export default {
  name: 'CourseShow',
  metaInfo() {
    return {
      title: 'Danh sách lớp học'
    }
  },
  data() {
    return {
      canSubmit: true,
      modelData: {
        id: 0,
        name: '',
        category_course_id: '',
        teacher_id: '',
        image: '',
        image_path: '',
        price: '',
        content: '',
        sale: '',
        date_start: '',
        date_end: '',
        course: {
          data: {
            name: '',
            category_course_text: '',
            teacher_txt: '',
            image_path: ''
          }
        },
        status: true
      },
      users: [],
      modalDataUser: [],
      modalDataTurTors: [],
      teacher: [],
      courses: [],
      isIndeterminate: true,
      checkedDates: [],
      checkAll: false,
      dateInWeek: [{
        name: 'Thứ 2',
        value: 1
      }, {
        name: 'Thứ 3',
        value: 2
      }, {
        name: 'Thứ 4',
        value: 3
      }, {
        name: 'Thứ 5',
        value: 4
      }, {
        name: 'Thứ 6',
        value: 5
      }, {
        name: 'Thứ 7',
        value: 6
      }, {
        name: 'Chủ nhật',
        value: 0
      }]
    }
  },
  mounted() {
    this.configBreadcrumb()
    this.fetchUsers()
    this.fetchModel()
    this.fetchUserInClass()
    this.fetchTurtorInclass()
    this.fetchCourse()
  },
  methods: {
    handleCheckAllChange(value) {
      this.modelData.date_in_week = value ? this.dateInWeek.map(item => item.value) : []
      console.log(this.modelData.date_in_week)
      this.isIndeterminate = false
    },
    handleCheckeDate(value) {
      console.log(value)
      let checkedCount = value.length
      this.checkAll = checkedCount === this.dateInWeek.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.dateInWeek.length
    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb() {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'class-live-index', text: 'Danh sách lớp học' },
        { name: 'class-live-create', text: 'Chi tiết lớp học' }
      ]

      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel() {
      this.$router.push({ name: 'class-live-index' })
    },
    // Tải dữ liệu Model xuống
    fetchModel() {
      this.canSubmit = false
      axios.get('get-class-live/' + this.$route.params.id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            this.modelData.date_in_week = this.modelData.date_in_week.split(',').map(item => parseInt(item))
            this.modelData.start_at = new Date(
              '2023 07 26 ' + this.modelData.start_at
            )

            this.modelData.end_at = new Date(
              '2023 07 26 ' + this.modelData.end_at
            )
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // get users
    fetchUsers() {
      this.canSubmit = false
      axios.get('get-users').then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.users = response.data.filter(item => item.user_type == 3)
            this.teacher = response.data.filter(item => item.user_type == 2)
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    //get user in class
    fetchUserInClass() {
      this.canSubmit = false
      axios.get('get-user-in-class/' + this.$route.params.id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modalDataUser = response.data.map(item => item.user.id)
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    //get turtor in class

    fetchTurtorInclass() {
      this.canSubmit = false
      axios.get('get-turtor-in-class/' + this.$route.params.id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modalDataTurTors = response.data.map(item => item.user.id)
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },

    fetchCourse() {
      this.canSubmit = false
      axios.get('get-courses').then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.courses = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })

    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.storeModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    storeModel() {
      this.canSubmit = false
      this.modelData.start_at = moment(this.modelData.start_at).format('HH:mm:ss')
      this.modelData.end_at = moment(this.modelData.end_at).format('HH:mm:ss')
      this.modelData.time_start = moment(this.modelData.time_start).format('YYYY-MM-DD')
      this.modelData.time_end = moment(this.modelData.time_end).format('YYYY-MM-DD')
      const data = {
        name: this.modelData.name,
        host_id: this.modelData.teacher.id,
        course_id: this.modelData.course_id,
        limit_account: this.modelData.limit_account,
        price: this.modelData.price,
        time_start: this.modelData.time_start,
        time_end: this.modelData.time_end,
        start_at: this.modelData.start_at,
        end_at: this.modelData.end_at,
        users: this.modalDataUser,
        turtors: this.modalDataTurTors,
        date_in_week: this.modelData.date_in_week,
        repeat: 1
      }
      axios.put('update-class/' + this.$route.params.id, data).then(response => {
        this.canSubmit = true
        if (response.code == 200) {
          this.$notify({
            title: 'Thành công',
            message: 'Cập nhật lớp học thành công',
            type: 'success'
          })
          this.$router.push({ name: 'class-live-index' })
        } else {
          let er = response.errors
          let message = head(er[Object.keys(er)[0]])
          this.$notify({
            title: 'Có lỗi xảy ra',
            message: message,
            type: 'warning'
          })
          this.modelData.start_at = new Date(
            '2023 07 26 ' + this.modelData.start_at
          )

          this.modelData.end_at = new Date(
            '2023 07 26 ' + this.modelData.end_at
          )
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}

.el-select,
el-date-editor,
el-time-picker,
el-input {
  width: 100% !important;
}

.el-date-editor,
el-time-picker {
  width: 100% !important;
  height: 0 !important;
  padding-top: 0;
}

.input-seach input {
  height: auto !important;
}
</style>

<style type="text/css"></style>



// WEBPACK FOOTER //
// src/components/class-live/Show.vue